import { render, staticRenderFns } from "./SanitasSearchModule.vue?vue&type=template&id=7b882b98&scoped=true&"
import script from "./SanitasSearchModule.vue?vue&type=script&lang=js&"
export * from "./SanitasSearchModule.vue?vue&type=script&lang=js&"
import style0 from "./SanitasSearchModule.vue?vue&type=style&index=0&id=7b882b98&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b882b98",
  null
  
)

export default component.exports